module.exports = __webpack_public_path__ + "img/ZG81_12.55e20105.jpg";